import { clone } from '@/utils/handleData.js'
import { filterPageTabs } from '@/utils/tabPages'
import home from '@/utils/pageParams/home.js'
import project from '@/utils/pageParams/project.js'
import enterprise from '@/utils/pageParams/enterprise.js'
import bidSection from '@/utils/pageParams/bidSection.js'
import person from '@/utils/pageParams/person.js'
import user from '@/utils/pageParams/user.js'
import role from '@/utils/pageParams/role.js'
import organization from '@/utils/pageParams/organization.js'
import fields from '@/utils/pageParams/fields.js'
import pages from '@/utils/pageParams/pages.js'
import attendanceSet from '@/utils/pageParams/attendanceSet.js'
import task from '@/utils/pageParams/task.js'
import division from '@/utils/pageParams/division.js'
import progress from '@/utils/pageParams/progress'
import billOfQuantities from '@/utils/pageParams/billOfQuantities'
import safetyInput from '@/utils/pageParams/safetyInput.js'
import materialManage from '@/utils/pageParams/materialManage.js'
import contractor from '@/utils/pageParams/contractor.js'
import team from '@/utils/pageParams/team.js'
import builder from '@/utils/pageParams/builder.js'
import contract from '@/utils/pageParams/contract.js'
import attendance from '@/utils/pageParams/attendance.js'
import salaryPay from '@/utils/pageParams/salaryPay.js'
import notice from '@/utils/pageParams/notice.js'
import training from '@/utils/pageParams/training.js'
import examine from '@/utils/pageParams/examine.js'
import preClassEducation from '@/utils/pageParams/preClassEducation.js'
import trainingMaterials from '@/utils/pageParams/trainingMaterials.js'
import materialLibrary from '@/utils/pageParams/materialLibrary.js'
import onlineExam from '@/utils/pageParams/onlineExam.js'
import examLibrary from '@/utils/pageParams/examLibrary.js'
import manageEvaluation from '@/utils/pageParams/manageEvaluation'
import officialCar from '@/utils/pageParams/officialCar'
import ownEquipment from '@/utils/pageParams/ownEquipment'
import pouringOrder from '@/utils/pageParams/pouringOrder'
import goodsShipment from '@/utils/pageParams/goodsShipment'
import mixingProduction from '@/utils/pageParams/mixingProduction'
import concealedWork from '@/utils/pageParams/concealedWork'
import domainBrand from '@/utils/pageParams/domainBrand.js'
import waterwheelWork from '@/utils/pageParams/waterwheelWork'
import mechanicalEquipment from '@/utils/pageParams/mechanicalEquipment'
import report from '@/utils/pageParams/report.js'
import preview from '@/utils/pageParams/preview.js'
import { applyBidLevelActionFilter } from '@/utils/bidLevelActions.js'

const pageStates = {
  project,
  buildProject: project,
  enterprise,
  bidSection,
  projectSection: bidSection,
  person,
  user,
  role,
  organization,
  fields,
  pages,
  attendanceSet,
  task,
  division,
  billOfQuantities,
  progress,
  safetyInput,
  materialManage,
  contractor,
  team,
  builder,
  contract,
  attendance,
  salaryPay,
  notice,
  report,
  proRealnameReport: report,
  preClassEduReport: report,
  training,
  examine,
  preClassEducation,
  trainingMaterials,
  publicMaterials: trainingMaterials,
  materialLibrary,
  paperLibrary: examLibrary,
  questionLibrary: examLibrary,
  publicPapers: examLibrary,
  publicQuestions: examLibrary,
  onlineExam,
  manageEvaluation,
  officialCar,
  ownEquipment,
  pouringOrder,
  goodsShipment,
  mixingProduction,
  concealedWork,
  domainBrand,
  waterwheelWork,
  mechanicalEquipment,
  preview,
  home
}

export function getParams(component, componentKey, state, getters) {
  var params = {
    component: component,
    componentKey: componentKey,
    state: state,
    getters: getters,
    dictionarys: state.dictionarys,
    orgFields: state.orgFields,
    validate: state.validate,
    pushData: state.pushData,
    pushDataInfo: state.pushDataInfo,
    pushResult: state.pushResult,
    formError: state.formError,
    activeNav: state.activeNav,
    radio: state.radio,
    // 不在此读取 selection，避免勾选触发 tables/check 整表重算；需要时用 params.state.selection
    currentRow: state.currentRow[componentKey],
    pageStatus: state.pageStatus[componentKey],
    formValues: state.formValues[componentKey],
    currentUids: state.currentUids[componentKey],
    queryValues: state.queryValues[componentKey],
    getTagData: getters[state.currentStep.theme + '/getTagData'],
    theme: state.currentStep.theme,
    step: state.currentStep.step,
    activeStep: state.activeStep,
    historyStep: state.historyStep,
    lastStep: state.historyStep[state.historyStep.length - 1],
    isSelectedDay: state.isSelectedDay,
    userName: state.user.userName,
    personName: state.user.personName,
    orgValue: state.user.orgValue,
    orgName: getters['user/orgName'],
    orgType: getters['user/orgType'],
    orgBuildType: getters['user/orgBuildType']
  }
  return params
}

export function getObjAttribute(data, params) {
  var obj = data
  if (obj) {
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        // 表单内嵌表格的 rowData 要随表单值现算，进页时不能先求成空数组
        if (
          typeof obj[key] === 'function' &&
          !(key === 'rowData' && obj.type === 'table')
        ) {
          obj[key] = obj[key](params)
        }
      }
    }
    if (obj.children) {
      getFields(obj.children, params)
    }
  }
  return obj
}

export function getFormRules(data, params) {
  var formRules = data
  if (formRules) {
    for (const key in formRules) {
      if (Object.hasOwnProperty.call(formRules, key)) {
        formRules[key].forEach((rule, index) => {
          formRules[key][index] = getObjAttribute(rule, params)
        })
      }
    }
  }
  return formRules
}

export function getFields(data, params) {
  // 每次从源配置浅拷贝字段再求值，避免把 options 等函数永久写成首次空数组
  var source = typeof data === 'function' ? data(params) : data
  if (source && Array.isArray(source)) {
    return source.map((item) => {
      return getObjAttribute(Object.assign({}, item), params)
    })
  }
  return source
}

export function getPageState(state, component) {
  var theme = Object.keys(state.currentStep).length
    ? state.currentStep.theme
    : 'home'
  const page =
    Object.keys(state.currentStep).length && state.currentStep.step
      ? state.currentStep.step.slice(0, -4)
      : ''
  const pageState = clone(page ? pageStates[theme][page] : pageStates[theme])
  if (
    pageState &&
    pageState.componentTypes &&
    pageState.componentTypes.includes(component)
  ) {
    return pageState
  }
}

// 获取tab页面切换参数
export function setPageTabs(state, getters) {
  var pageTab
  const theme = state.currentStep.theme
  const pageState = getPageState(state, 'pageTabs')
  if (pageState) {
    const params = getParams('pageTabs', pageState.name, state, getters)
    pageTab =
      typeof pageStates[theme].pageTabs === 'function'
        ? pageStates[theme].pageTabs(params)
        : pageStates[theme].pageTabs
    return filterPageTabs(pageTab, getters['user/pages'], theme)
  }
}

// 获取navBar导航参数
export function setNavBar(state, getters) {
  var navBar
  const theme = state.currentStep.theme
  const pageState = getPageState(state, 'navBar')
  if (pageState) {
    const params = getParams('navBar', pageState.name, state, getters)
    navBar =
      typeof pageStates[theme].navBar === 'function'
        ? pageStates[theme].navBar(params)
        : pageStates[theme].navBar
    navBar = getObjAttribute(navBar, params)
    return navBar
  }
}

// 获取calendars日历数据
export function setCalendars(state, getters) {
  var calendars
  const pageState = getPageState(state, 'calendars')
  if (pageState) {
    const params = getParams('calendars', pageState.name, state, getters)
    calendars = pageState
    calendars = getObjAttribute(calendars, params)
    calendars.detailPage = getFields(calendars.detailPage, params)
    applyBidLevelActionFilter(calendars, params.orgType, params.theme, params.state)
    return calendars
  }
}

// 获取查询组件信息
export function setCheck(state, getters) {
  var check
  const pageState = getPageState(state, 'check')
  if (pageState) {
    const params = getParams('check', pageState.name, state, getters)
    // 浅拷贝并断开会回写源配置的字段，保证 options 等函数可重复求值
    const rawSelectData = pageState.selectData
    const rawDetailPage = pageState.detailPage
    const rawQueryParams = pageState.queryParams
    const rawQueryRules = pageState.queryRules
    check = Object.assign({}, pageState)
    check.selectData = null
    check.detailPage = null
    check.queryParams = Object.assign({}, rawQueryParams || {})
    check.queryRules = rawQueryRules
    check = getObjAttribute(check, params)
    check.theme = state.currentStep.theme
    check.title = state.currentStep.label
    check.queryFun = pageState.queryFun
      ? pageState.queryFun
      : pageState.getListFun
    check.queryParams = getObjAttribute(
      Object.assign({}, rawQueryParams || {}),
      params
    )
    check.queryRules = getFormRules(rawQueryRules, params)
    check.selectData = getFields(rawSelectData, params)
    check.detailPage = getFields(rawDetailPage, params)
    check.detailPage &&
      check.detailPage.forEach((item) => {
        if (item.detailData) {
          item.detailData = getObjAttribute(
            Object.assign({}, item.detailData),
            params
          )
        }
      })
    applyBidLevelActionFilter(check, params.orgType, params.theme, params.state)
    return check
  }
}
// 获取列表组件数据信息
export function setTables(state, getters) {
  var tables
  const pageState = getPageState(state, 'tables')
  if (pageState) {
    const params = getParams('tables', pageState.name, state, getters)
    const sourceRowTotal = pageState.rowTotal
    const sourceRowData = pageState.rowData
    tables = pageState
    tables = getObjAttribute(tables, params)
    tables.theme = state.currentStep.theme
    tables.title = state.currentStep.label
    // 前端筛选列表（如试卷题型 tab）每次按当前数据重算总数，避免沿用「全部」时的条数
    if (
      typeof sourceRowTotal !== 'function' &&
      typeof sourceRowData === 'function' &&
      Array.isArray(tables.rowData)
    ) {
      tables.rowTotal = tables.rowData.length
    } else if (!tables.rowTotal && tables.rowData) {
      tables.rowTotal = tables.rowData.length
    }
    tables.columns = getFields(tables.columns, params)
    tables.columns.forEach((item) => {
      if (item.tooltip) {
        item.tooltip = getObjAttribute(item.tooltip, params)
      }
      if (item.formItem) {
        item.formItem = getObjAttribute(item.formItem, params)
      }
    })
    tables.detailPage = getFields(tables.detailPage, params)
    tables.detailPage &&
      tables.detailPage.forEach((item) => {
        if (item.detailData) {
          item.detailData = getObjAttribute(item.detailData, params)
        }
      })
    applyBidLevelActionFilter(tables, params.orgType, params.theme, params.state)
    return tables
  }
}
// 获取dialogTable列表数据信息
export function setDialogTable(state, getters) {
  var dialogTable
  const pageState = getPageState(state, 'dialogTable')
  if (pageState && state.dialogName && pageState[state.dialogName]) {
    const params = getParams('dialogTable', state.dialogName, state, getters)
    dialogTable = pageState[state.dialogName]
    dialogTable = getObjAttribute(dialogTable, params)
    if (dialogTable.upload) {
      dialogTable.rowData = state.filesData
    }
    if (dialogTable.push) {
      dialogTable.rowData = state.pushResult.length
        ? state.pushResult
        : state.pushDataInfo
    }
    if (
      !dialogTable.rowTotal &&
      dialogTable.rowData &&
      dialogTable.hasPagination
    ) {
      dialogTable.rowTotal = dialogTable.rowData.length
    }
    dialogTable.columns = getFields(dialogTable.columns, params)
    dialogTable.columns.forEach((item) => {
      if (item.tooltip) {
        item.tooltip = getObjAttribute(item.tooltip, params)
      }
      if (item.formItem) {
        item.formItem = getObjAttribute(item.formItem, params)
      }
    })
    dialogTable.detailPage = getFields(dialogTable.detailPage, params)
    dialogTable.detailPage &&
      dialogTable.detailPage.forEach((item) => {
        if (item.detailData) {
          item.detailData = getObjAttribute(item.detailData, params)
        }
      })
    applyBidLevelActionFilter(dialogTable, params.orgType, params.theme, params.state)
    return dialogTable
  }
}
// 获取drawerTable列表数据信息
export function setDrawerTable(state, getters) {
  var drawerTable
  const pageState = getPageState(state, 'drawerTable')
  if (pageState && state.drawerName && pageState[state.drawerName]) {
    const params = getParams('drawerTable', state.drawerName, state, getters)
    drawerTable = pageState[state.drawerName]
    drawerTable = getObjAttribute(drawerTable, params)
    if (
      !drawerTable.rowTotal &&
      drawerTable.rowData &&
      drawerTable.hasPagination
    ) {
      drawerTable.rowTotal = drawerTable.rowData.length
    }
    drawerTable.columns = getFields(drawerTable.columns, params)
    drawerTable.columns.forEach((item) => {
      if (item.tooltip) {
        item.tooltip = getObjAttribute(item.tooltip, params)
      }
      if (item.formItem) {
        item.formItem = getObjAttribute(item.formItem, params)
      }
    })
    drawerTable.queryParams = getObjAttribute(drawerTable.queryParams, params)
    drawerTable.queryRules = getFormRules(drawerTable.queryRules, params)
    drawerTable.selectData = getFields(drawerTable.selectData, params)
    drawerTable.detailPage = getFields(drawerTable.detailPage, params)
    drawerTable.detailPage &&
      drawerTable.detailPage.forEach((item) => {
        if (item.detailData) {
          item.detailData = getObjAttribute(item.detailData, params)
        }
      })
    applyBidLevelActionFilter(drawerTable, params.orgType, params.theme, params.state)
    return drawerTable
  }
}
// 获取cardForm表单数据信息
export function setCardForm(state, getters) {
  var cardForm
  const pageState = getPageState(state, 'cardForm')
  if (pageState) {
    cardForm = pageState
    cardForm.parentKey = cardForm.name
    cardForm.cardFormNames.forEach((item) => {
      const itemParams = getParams('cardForm', item, state, getters)
      cardForm[item] = getObjAttribute(cardForm[item], itemParams)
      cardForm[item].formParams = getObjAttribute(
        cardForm[item].formParams,
        itemParams
      )
      cardForm[item].formRules = getFormRules(
        cardForm[item].formRules,
        itemParams
      )
      cardForm[item].formData.forEach((card) => {
        card = getObjAttribute(card, itemParams)
        card.fields = getFields(card.fields, itemParams)
      })
    })
    const params = getParams('cardForm', cardForm.name, state, getters)
    cardForm.detailPage = getFields(cardForm.detailPage, params)
    cardForm.detailPage &&
      cardForm.detailPage.forEach((item) => {
        if (item.detailData) {
          item.detailData = getObjAttribute(item.detailData, params)
        }
      })
    cardForm.cardFormNames.forEach((item) => {
      applyBidLevelActionFilter(cardForm[item], params.orgType, params.theme, params.state)
    })
    return cardForm
  }
}
// 获取collapses折叠面板数据信息
export function setCollapses(state, getters) {
  var collapses = {}
  const pageState = getPageState(state, 'collapses')
  if (pageState) {
    collapses = pageState
    collapses.parentKey = collapses.name
    collapses.collapsesNames.forEach((item) => {
      const itemParams = getParams('collapses', item, state, getters)
      collapses[item] = getObjAttribute(collapses[item], itemParams)
      collapses[item].collapsesData = getFields(
        collapses[item].collapsesData,
        itemParams
      )
    })
    const params = getParams('collapses', collapses.name, state, getters)
    collapses.detailPage = getFields(collapses.detailPage, params)
    collapses.detailPage &&
      collapses.detailPage.forEach((item) => {
        if (item.detailData) {
          item.detailData = getObjAttribute(item.detailData, params)
        }
      })
    collapses.collapsesNames.forEach((item) => {
      applyBidLevelActionFilter(collapses[item], params.orgType, params.theme, params.state)
    })
    return collapses
  }
}
// 获取stepForm表单数据信息
export function setStepForm(state, getters) {
  var stepForm
  const pageState = getPageState(state, 'stepForm')
  if (pageState) {
    stepForm = pageState
    const params = getParams('stepForm', pageState.name, state, getters)
    stepForm = getObjAttribute(stepForm, params)
    stepForm.theme = state.currentStep.theme
    stepForm.title = state.currentStep.label
    stepForm.formParams = getObjAttribute(stepForm.formParams, params)
    stepForm.formRules = getFormRules(stepForm.formRules, params)
    stepForm.formData = getObjAttribute(stepForm.formData, params) || {}
    if (!stepForm.formData.fields) {
      stepForm.formData.fields = []
    }
    stepForm.formData.fields = getFields(stepForm.formData.fields, params)
    stepForm.detailPage = getFields(stepForm.detailPage, params)
    stepForm.detailPage &&
      stepForm.detailPage.forEach((item) => {
        if (item.detailData) {
          item.detailData = getObjAttribute(item.detailData, params)
        }
      })
    applyBidLevelActionFilter(stepForm, params.orgType, params.theme, params.state)
    return stepForm
  }
}
// 获取dialogForm列表数据信息
export function setDialogForm(state, getters) {
  var dialogForm
  const pageState = getPageState(state, 'dialogForm')
  if (pageState && state.dialogName && pageState[state.dialogName]) {
    dialogForm = pageState[state.dialogName]
    const params = getParams('dialogForm', state.dialogName, state, getters)
    dialogForm = getObjAttribute(dialogForm, params)
    if (!dialogForm.title && dialogForm.dialogTitle) {
      dialogForm.title = dialogForm.dialogTitle
    }
    if (!dialogForm.getParentFun) {
      dialogForm.getParentFun = dialogForm.getListFun
    }
    dialogForm.formParams = getObjAttribute(dialogForm.formParams, params)
    dialogForm.formRules = getFormRules(dialogForm.formRules, params)
    dialogForm.formData = getFields(dialogForm.formData, params)
    dialogForm.detailPage = getFields(dialogForm.detailPage, params)
    dialogForm.detailPage &&
      dialogForm.detailPage.forEach((item) => {
        if (item.detailData) {
          item.detailData = getObjAttribute(item.detailData, params)
        }
      })
    applyBidLevelActionFilter(dialogForm, params.orgType, params.theme, params.state)
    return dialogForm
  }
}
// 获取deviceData数据信息
export function setDeviceData(state, getters) {
  var deviceData
  const pageState = getPageState(state, 'deviceData')
  if (pageState) {
    deviceData = pageState
    const params = getParams('deviceData', pageState.name, state, getters)
    deviceData = getObjAttribute(deviceData, params)
    deviceData.formData = getObjAttribute(deviceData.formData, params)
    deviceData.formData.fields = getFields(deviceData.formData.fields, params)
    return deviceData
  }
}
